import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import affyn from '../../../assets/images/virtualstart/affyn.jpg';

import './furthur_styles/affyn.css';

export default function Affyn() {
  return (
    <>
      <Container className='mt-5 mb-5 affyn_fur'>
            <div className="card affyn_card">
        <Row>
          <Col lg={6} md={12}>
                <img src={affyn} alt="Affyn images" className='img-flui rounded' />
          </Col>
          <Col>
            <h3>Affyn</h3>
            <div className="affyn_btns d-flex gap-3">
                <Button>NONINITIAL</Button>
                <Button>Airdrop</Button>
            </div>
            <div>
                <p>21,852 <span>Supporter</span></p>
            </div>
            <div>
                <p>69,634,820 <span>/100,000 USDT</span></p>
            </div>
            <div>
                  <div>
                    <span>69,634.82% raised</span>
                  </div>
                  <div className="affyn_lower_bar">
                    <div className="affyn_lower_bar_in"></div>
                  </div>
            </div>
            <div className="affyn_time mt-5">
                <p>Start time: 2023-05-02 14:00:00 UTC+5</p>
                <p>End time: 2023-05-03 14:00:00 UTC+5</p>
            </div>
            <div className='affyn_succed rounded'>
                <h5>Succeeded</h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <div>
              <p>One Share: <span>20 USDT</span></p>
            </div>
            <div>
              <p>Allocation / Share: <span>392.1568 FYN</span></p>
            </div>
            <div>
              <p>Total Shares: <span>5000</span></p>    
            </div>
          </Col>  
          <Col>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
            <div>
              <p>Eligibility: <span>KYC 2 users</span></p>
            </div>
            <div>
              <p>Cost: <span>Free</span></p>    
            </div>
            </div>
            <div className='w-50 affyn_card_low_btn d-flex justify-content-center align-items-center me-auto ms-auto'>
              <Button className='w-100' disabled>Finished</Button>
            </div>
            </div>
          </Col>
        </Row>
            </div>
      </Container>
    </>
  )
}
